import { useState } from "react";

export function useOrderDialog(defaultState) {
  const [openOrderDialog, setOpenOrderDialog] = useState(defaultState || false);
  return {
    openOrderDialog,
    setOpenOrderDialog
  };
}
